import React from 'react'
import { ToastContainer, toast } from 'react-toastify'

import { CloseButton } from './CloseButton'
import { MessageWrapper } from './MessageWrapper'
import { Container } from './styles/main'

const toastr = Object.assign(toast)

const ToastrContainer = props => {
  return (
    <Container>
      <ToastContainer
        closeButton={<CloseButton />}
        closeOnClick={false}
        pauseOnHover={false}
        pauseOnFocusLoss={false}
        position={toastr.POSITION.BOTTOM_RIGHT}
        autoClose={false}
        {...props}
      />
    </Container>
  )
}

toastr._error = toastr.error
toastr.error = function error(message, options = {}) {
  return toastr._error(
    <MessageWrapper level="error" autoClose={options.autoClose}>
      {message}
    </MessageWrapper>,
    options,
  )
}

toastr._info = toastr.info
toastr.info = function info(message, options = {}) {
  return toastr._info(
    <MessageWrapper level="info" autoClose={options.autoClose}>
      {message}
    </MessageWrapper>,
    options,
  )
}

export { ToastrContainer, toastr }
